export const ko = {
  // Navigation
  'nav.search.placeholder': '스레드, 채용공고, 질문 검색...',
  'nav.anonymous.mode': '[익명_모드]',
  
  // Sidebar Menu
  'menu.feed': '피드',
  'menu.jobs': '채용',
  'menu.study': '스터디',
  'menu.knowledge': '지식',
  'menu.news': '뉴스',
  'menu.bugbounty': '버그바운티',
  'menu.learning': '학습',
  'menu.premium': '프리미엄',
  
  // Feed Tab
  'feed.title': '실시간 피드',
  'feed.new.post': '+ 새 게시글',
  'feed.category.all': '전체',
  'feed.category.vulnerability': '취약점',
  'feed.category.study': '스터디',
  'feed.category.job': '채용',
  'feed.category.knowledge': '지식',
  'feed.replies': '답글',
  'feed.likes': '좋아요',
  
  // Jobs Tab
  'jobs.title': '채용 게시판',
  'jobs.post.job': '+ 채용공고 등록',
  'jobs.salary': '연봉',
  'jobs.location': '위치',
  'jobs.experience': '경력',
  'jobs.apply.now': '[지원하기]',
  
  // Study Tab
  'study.title': '스터디 Q&A',
  'study.ask.question': '+ 질문하기',
  'study.answers': '답변',
  'study.views': '조회',
  'study.solved': '✓ 해결됨',
  
  // Knowledge Tab
  'knowledge.title': '해커 지식인',
  'knowledge.subtitle': '실시간 해킹 지식 Q&A - 현상금 시스템',
  'knowledge.ask.bounty': '+ 현상금 질문하기',
  'knowledge.answered': '✓ 답변완료',
  'knowledge.pending': '⏱ 대기중',
  'knowledge.points': '포인트',
  
  // Learning Tab
  'learning.title': '학습 사이트',
  'learning.subtitle': '해킹 학습을 위한 엄선된 사이트 모음',
  'learning.difficulty': '난이도',
  'learning.users': '사용자',
  
  // Premium Tab
  'premium.title': '프리미엄 아카이브',
  'premium.subtitle': '실전 해킹 시행착오 아카이브 - 프리미엄 회원 전용',
  'premium.only': '프리미엄 전용',
  'premium.exclusive': '프리미엄 회원 전용 콘텐츠',
  'premium.cases': '케이스',
  'premium.membership': '프리미엄 멤버십',
  'premium.description': '실전 해킹 시행착오 아카이브, 전문가 1:1 멘토링, 프리미엄 스터디 그룹 등 모든 프리미엄 콘텐츠에 무제한 액세스',
  'premium.price': '₩99,000 / 월',
  'premium.upgrade.now': '[업그레이드]',
  'premium.modal.title': '프리미엄 멤버십 필요',
  'premium.modal.description': '이 콘텐츠는 프리미엄 회원 전용입니다. 실전 해킹 시행착오 아카이브와 모든 프리미엄 기능을 이용하세요.',
  'premium.modal.upgrade': '[프리미엄 업그레이드]',
  'premium.modal.close': '[닫기]',
  
  // Sidebar Stats
  'stats.title': '// 실시간 통계',
  'stats.online.hackers': '온라인 해커',
  'stats.today.posts': '오늘 게시글',
  'stats.active.threads': '활성 스레드',
  'stats.trending.tags': '// 트렌딩 태그',
  'stats.top.hackers': '// 탑 해커',
  
  // Time
  'time.minutes.ago': '분 전',
  'time.hour.ago': '시간 전',
  'time.hours.ago': '시간 전',
  'time.realtime': '실시간',

  // Search
  'search.input.placeholder': '게시글, 채용공고, 질문을 검색하세요...',
  'search.tab.all': '전체',
  'search.tab.feed': '피드',
  'search.tab.jobs': '채용',
  'search.tab.study': '스터디',
  'search.tab.knowledge': '지식인',
  'search.trending': '트렌딩 태그',
  'search.popular': '인기 게시글',
  'search.results.count': '개의 검색 결과',
  'search.sort.relevance': '관련도',
  'search.sort.latest': '최신순',
  'search.sort.popular': '인기순',
  'search.no.results': '검색 결과가 없습니다',
  'search.no.results.hint': '다른 키워드로 검색해보세요',
  'search.just.now': '방금',
  'search.type.feed': 'FEED',
  'search.type.job': 'JOB',
  'search.type.study': 'STUDY',
  'search.type.knowledge': 'KNOWLEDGE',

  // Notifications
  'notifications.title': '알림',
  'notifications.all': '전체',
  'notifications.unread': '읽지 않음',
  'notifications.mark.all.read': '모두 읽음',
  'notifications.no.unread': '읽지 않은 알림이 없습니다',
  'notifications.no.notifications': '알림이 없습니다',
  'notifications.new': '새 알림',
  'notifications.delete': '삭제',

  // News Tab
  'news.title': '실시간 해킹뉴스',
  'news.subtitle': 'Hacker News & 커뮤니티 보안 뉴스',
  'news.share.news': '+ 뉴스 공유',
  'news.category.all': '전체',
  'news.category.vulnerability': '취약점',
  'news.category.breach': '데이터유출',
  'news.category.malware': '악성코드',
  'news.category.bounty': '버그바운티',
  'news.community': '커뮤니티',
  bugbounty: {
    title: '버그바운티존',
    subtitle: '글로벌 버그바운티 프로그램과 최신 취약점 리포트를 확인하세요',
    platforms: {
      title: '버그바운티 플랫폼',
    },
    writeups: {
      title: '최근 공개된 Writeup',
    },
    tips: {
      title: '버그바운티 시작 가이드',
      start: {
        title: '작은 것부터 시작하기',
        description: '처음에는 난이도가 낮은 프로그램부터 시작하세요. XSS, IDOR, CSRF 같은 기본적인 취약점을 찾는 연습을 하고, 점차 복잡한 취약점으로 확장해 나가세요.',
      },
      tools: {
        title: '필수 도구 익히기',
        description: 'Burp Suite, OWASP ZAP, Nuclei, ffuf, SQLMap 등의 도구를 익히세요. 자동화 도구와 수동 테스트를 병행하면 더 많은 취약점을 발견할 수 있습니다.',
      },
      report: {
        title: '명확한 리포트 작성',
        description: '취약점을 발견했다면 재현 단계, 영향도, PoC를 명확하게 작성하세요. 좋은 리포트는 빠른 검증과 높은 보상으로 이어집니다.',
      },
      community: {
        title: '커뮤니티 참여',
        description: 'Twitter, Discord, Reddit의 버그바운티 커뮤니티에 참여하세요. 다른 헌터들의 writeup을 읽고, 최신 트렌드와 기법을 배울 수 있습니다.',
      },
    },
  },
};

export default ko;
